<template lang="pug">
div
    modal(v-show="isShowModal_",:titulo="'NUEVA ' + nameModulo.toUpperCase()"  bindClass="col-md-4 col-sm-12" , @close="isShowModal_=false")
        div(slot='body')  
            .form-group
                .form-row
                    .col-md-4.col-sm-12
                        label RUT
                        input.form-control.form-control-sm(v-model="parameter.RUT", @keypress.enter="sendInfo()")
                    .col-md-8.col-sm-12
                        label Razon Social
                        input.form-control.form-control-sm(v-model="parameter.BusinessName")
                .form-row
                    .col-md-12.col-sm-12
                        label Giro
                        input.form-control.form-control-sm(v-model="parameter.ActivityEnterprises")              
                .form-row
                    .col-md-12.col-sm-12
                        label Direccion
                        input.form-control.form-control-sm(v-model="parameter.Adress")
                .form-row
                    .col-md-6.col-sm-12
                        label Nombre Contacto
                        input.form-control.form-control-sm(v-model="parameter.ContactName")
                    .col-md-6.col-sm-12
                        label Telefono Contacto
                        input.form-control.form-control-sm(v-model="parameter.ContactPhone")
                .form-row 
                    .col-md-6.col-sm-12
                        label Email Contacto
                        input.form-control.form-control-sm(v-model="parameter.ContactEmail")
                    .col-md-6.col-sm-12
                        label Cargo Contacto
                        input.form-control.form-control-sm(v-model="parameter.ContactPosition")
                .form-row
                    .col-md-12.col-sm-12
                        label Nombre Imagen
                        input.form-control.form-control-sm(v-model="parameter.NameFileImg")
                .form-row
                    .col-md-6.col-sm-12
                        label Movil Android
                        div
                            i.fa.fa-toggle-off.fa-2x(v-if="parameter.APP_ANDROID_ACTIVE==2", @click="parameter.APP_ANDROID_ACTIVE=1")  OFF                                                    
                            i.fa.fa-toggle-on.fa-2x(v-if="parameter.APP_ANDROID_ACTIVE==1" ,@click="parameter.APP_ANDROID_ACTIVE=2" )   ON 
                    .col-md-6.col-sm-12
                        label Android Build
                        input.form-control.form-control-sm(v-model="parameter.APP_ANDROID_BUILD")
                .form-row
                    .col-md-6.col-sm-12
                        label Movil IOS
                        div
                            i.fa.fa-toggle-off.fa-2x(v-if="parameter.APP_IOS_ACTIVE==2", @click="parameter.APP_IOS_ACTIVE=1")  OFF                                                    
                            i.fa.fa-toggle-on.fa-2x(v-if="parameter.APP_IOS_ACTIVE==1" ,@click="parameter.APP_IOS_ACTIVE=2" )   ON 
                    .col-md-6.col-sm-12
                        label IOS Build
                        input.form-control.form-control-sm(v-model="parameter.APP_IOS_BUILD")
        div(slot='footer')
            button.btn.btn-primary(@click="sendInfo()") Guardar
</template>
<script>
import modal from "../../../complementos/modal.vue"
import toolValidate from '../../../tools/validate.js'
export default {
    props:{ 
        nameModulo:String,
        IsShowModal:Boolean,
        parameter:Object
    },  
    components:{
        modal
    },
    computed:{
        isShowModal_ :{
                        get(){return this.IsShowModal },
                        set(val){this.$emit("update:IsShowModal",val)}
        } 
    },
    methods:{ 
            sendInfo(){
                if(this.validate()){
                    this.$emit("update:parameter",this.parameter)
                    this.$emit("sendInfo",this.parameter)
                }       
            },
            validate(){ 
                if(!toolValidate.valida_rut(this.parameter.RUT)){
                    this.$msgbox.show("RUT No Valido","Alerta")
                    return false
                }
                else if(this.parameter.RUT=='' || this.parameter.RUT==null ){
                    this.$msgbox.show("Ingrese RUT","Alerta")
                    return false
                }
                else if(this.parameter.BusinessName=='' || this.parameter.BusinessName==null ){
                    this.$msgbox.show("Ingrese Razon Social","Alerta")
                    return false
                }
                else if(this.parameter.ActivityEnterprises=='' || this.parameter.ActivityEnterprises==null ){
                    this.$msgbox.show("Ingrese Giro","Alerta")
                    return false
                }
                else if(this.parameter.Adress=='' || this.parameter.Adress==null ){
                    this.$msgbox.show("Ingrese Direccion","Alerta")
                    return false
                }
                else{
                    return true
                }
            }
    }

    
}
</script>